import React, { useCallback } from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { DatavizTopPosts } from "@radarly/models/dataviz";
import { SearchFragmentPosts } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import PostsSort from "@radarly/shared/cards/subtitle/posts-sort";
import Tile from "@radarly/shared/cards/tile";
import TopPosts from "@radarly/shared/widgets/posts/top-posts";
import { CardFragmentProps } from "../model";

const RadarlyPostsCardsTopPosts = ({
  title,
  fragment,
  project,
  height,
  openPostsPanel,
  timezone,
  forceReload,
  nowDate,
  dataviz,
}: CardFragmentProps<SearchFragmentPosts, DatavizTopPosts>) => {
  const { from, to } = getDateFromClause(fragment.request.query);
  const onClickItem = useCallback(() => {
    openPostsPanel({
      clause: fragment.request.query,
      period: {
        from,
        to,
      },
      title: title,
      timezone,
      sortBy: fragment.request.pagination.sort.on,
    });
  }, [
    fragment.request.pagination.sort.on,
    fragment.request.query,
    from,
    openPostsPanel,
    timezone,
    title,
    to,
  ]);
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <PostsSort fragment={fragment} />,
          ]}
        />
      }
      clause={fragment.request.query}
    >
      <TopPosts
        project={project.id}
        fragment={fragment}
        onClick={openPostsPanel ? onClickItem : null}
        forceReload={forceReload}
        dataviz={dataviz}
      />
    </Tile>
  );
};

export default RadarlyPostsCardsTopPosts;
